import { useUserProvider } from "./provider";
import { HStack, Text } from "@chakra-ui/react";
import "./index.css";
import { Link } from "react-router";
import useProfile from "../../hooks/data/useProfile";
import { TextEditable } from "../reusables";
/**
 *
 * @param {import("@chakra-ui/react").StackProps & import("./props").UserProps & { variant?: 'fullName' | 'username' }} props
 * @returns
 */
const Name = (props) => {
  const user = useUserProvider();
  const { updateProfile } = useProfile();

  function formatName(_username) {
    if (props.variant === "fullName") return user.fullName;
    const { username } = user;
    return username.startsWith("@") ? username : `@${username}`;
  }

  function handleChange({ fullName }) {
    updateProfile({ uid: user.id, data: { fullName } });
  }

  return (
    <HStack
      fontSize={props.variant === "fullName" ? "14px" : "12px"}
      fontWeight={props.variant === "username" && "semibold"}
      color={props.variant === "fullName" ? "white" : "gray.400"}
      id={
        props.variant === "fullName"
          ? "user-name-main"
          : "user-extra-elem-container"
      }
      {...props}
    >
      {user.allowEdit && props.variant === "fullName" ? (
        <TextEditable
          // lineHeight="none"
          value={user?.fullName}
          onChange={(text) => handleChange({ fullName: text })}
        />
      ) : (
        <Text as={"h4"} noOfLines={1}>
          {formatName()}
        </Text>
      )}

      {props.children}
    </HStack>
  );
};

export default Name;
